import {
  BaseLocaleStorage,
  PossibleLocalesType,
} from '@arsnovasystems/ars-front-lib';

/**
 * Class to handle local storage of our app
 */
class LocalStorageInner extends BaseLocaleStorage {
  /**
   * Delegated constructor
   *
   * @param prefix key prefix
   */
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(prefix: string) {
    // needed for ts
    super(prefix);
  }

  /**
   * to fet the locale from the localeStorage
   *
   * @returns string or undefined
   */
  getLocale(): PossibleLocalesType | undefined {
    if (this.getItem('locale') === null) return undefined;
    return this.getItem('locale') as PossibleLocalesType;
  }
  /**
   * to set the Locale to the locale Storage
   *
   * @param value the locale string value
   */
  setLocale(value: PossibleLocalesType) {
    this.setItem('locale', value);
  }

  /**
   * to set the email to the localStorage
   *
   * @param emailValue string representing the email or undefined when we want to clear the value
   */
  setEmail(emailValue: string | undefined) {
    if (emailValue === undefined) {
      this.removeItem('email');
      return;
    }

    this.setItem('email', emailValue);
  }
  /**
   * to get the Email from the localStorage
   *
   * @returns the string or undefined representing the value
   */
  getEmail(): string | undefined {
    const value = this.getItem('email');
    if (value === null) return undefined;
    return value;
  }
}

export const LocalStorage = new LocalStorageInner('partnerConsole');
